<nb-card class="helix-popup-body" [nbSpinner]="isLoading$ | async">
  <nb-card-header>
    <div class="header-container">{{ assetName }}</div>
  </nb-card-header>
  <nb-card-body>
    <p-table
      [value]="assetDocuments$ | async"
      styleClass="p-datatable-striped"
      [tableStyle]="{ 'min-width': '50rem' }"
      [rows]="5"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[5, 10, 25]"
      [paginator]="true"
      sortField="documentUploadedDate"
      sortOrder="-1"
      showInitialSortBadge="false"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="originalFileName">
            File
            <p-sortIcon field="originalFileName"></p-sortIcon>
          </th>
          <th pSortableColumn="caption">
            Caption
            <p-sortIcon field="caption"></p-sortIcon>
          </th>
          <th pSortableColumn="documentUploadedBy">
            UploadedBy
            <p-sortIcon field="documentUploadedBy"></p-sortIcon>
          </th>
          <th pSortableColumn="documentUploadedDate">
            UploadedDate <p-sortIcon field="documentUploadedDate"></p-sortIcon>
          </th>
          <th>Actions</th>
        </tr>
        <tr>
          <th>
            <p-columnFilter
              type="text"
              field="originalFileName"
              matchMode="contains"
              (click)="$event.stopPropagation()"
            >
            </p-columnFilter>
          </th>
          <th>
            <p-columnFilter
              type="text"
              field="caption"
              matchMode="contains"
              (click)="$event.stopPropagation()"
            >
            </p-columnFilter>
          </th>
          <th>
            <p-columnFilter
              field="documentUploadedBy"
              matchMode="in"
              [showMenu]="false"
            >
              <ng-template
                pTemplate="filter"
                let-value
                let-filter="filterCallback"
              >
                <p-multiSelect
                  [ngModel]="value"
                  [options]="documentUploadedByUsers$ | async"
                  placeholder="Any"
                  (onChange)="filter($event.value)"
                  optionLabel="name"
                >
                  <ng-template let-option pTemplate="item">
                    <div class="p-multiselect-uploadedby-option">
                      <span class="ml-1">{{ option }}</span>
                    </div>
                  </ng-template>
                </p-multiSelect>
              </ng-template>
            </p-columnFilter>
          </th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-assetDocument>
        <tr>
          <td>
            <img [src]="assetDocument.icon" alt="File Icon" class="file-icon" />
            <span> {{ assetDocument.originalFileName }} </span>
          </td>
          <td>{{ assetDocument.caption }}</td>
          <td>{{ assetDocument.documentUploadedBy }}</td>
          <td>
            {{
              assetDocument.documentUploadedDate | date: "yyyy-MM-dd HH:mm:ss"
            }}
          </td>
          <td>
            <button
              nbButton
              status="primary"
              class="btn-primary btn-outline btn-small"
              (click)="getAssetDocument(assetDocument)"
            >
              Download
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div
      *ngIf="hasDocumentCreateAccess$ | async"
      id="upload-document-btn-container"
    >
      <button
        nbButton
        status="primary"
        class="btn-primary btn-outline btn-small"
        (click)="uploadDocument()"
      >
        Upload Document
      </button>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button
      nbButton
      status="primary"
      class="btn-primary btn-outline btn-small"
      (click)="close()"
      i18n="@@asset-document-close"
    >
      Close
    </button>
  </nb-card-footer>
</nb-card>
